module.exports = __webpack_public_path__ + "static/img/gz-kf.cb15f03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/gz-kf.jpg
// module id = WaCL
// module chunks = 1